import { TodoComponent } from '../shared/windows/todo.component';
import { NftComponent } from '../shared/windows/nft.component';
import { EPIC_NFT_ANIMATION } from '../shared/windows/window.tokens';
import { ChatComponent } from '../shared/windows/chat.component';
import { MinesweeperComponent } from '../shared/windows/minesweeper.component';
import { DesktopApp } from '../shared/interfaces/desktop-app.interface';
import { KeygenComponent } from '../shared/windows/keygen.component';

export const DESKTOP_APPS: DesktopApp[] = [
  {
    id: 'gang',
    title: 'Cypher Gang',
    iconSrc: 'assets/img/cyphergang.png',
    action: {
      kind: 'window',
      component: NftComponent,
      position: { x: 100, y: 50 },
      size: { width: 700, height: 520 },
      animation: EPIC_NFT_ANIMATION,
    },
  },
  {
    id: 'fly',
    title: 'Cypher Fly',
    iconSrc: 'assets/img/cypher-fly.svg',
    action: { kind: 'navigate', route: '/cypher-fly' },
  },
  {
    id: 'chat',
    title: 'Cypher Chat',
    iconSrc: 'assets/img/cypher_chat.svg',
    action: {
      kind: 'window',
      component: ChatComponent,
      position: { x: 240, y: 60 },
      size: { width: 520, height: 420 },
    },
  },
  {
    id: 'keygen',
    title: 'Patch_C_Fly v0.0.1_FINAL',
    iconSrc: 'assets/img/keygen.png',
    action: {
      kind: 'window',
      component: KeygenComponent,
      position: { x: 240, y: 60 },
      size: { width: 520, height: 420 },
    },
  },
  {
    id: 'todo',
    title: 'To‑Do',
    iconSrc: 'assets/img/todo.svg',
    action: {
      kind: 'window',
      component: TodoComponent,
      position: { x: 360, y: 80 },
      size: { width: 560, height: 460 },
    },
  },
  {
    id: 'minesweeper',
    title: 'Minesweeper',
    iconSrc: 'assets/img/minesweeper.png',
    action: {
      kind: 'window',
      component: MinesweeperComponent,
      position: { x: 360, y: 80 },
      size: { width: 560, height: 460 },
    },
  },
];
